<template>
  <div class="shop_list">
    <!-- <li
      v-for="(item, index) in dataList"
      :key="index"
      @click="toDetails(item.id)"
    >
      <div class="pro_pic">
        <img :src="item.picHead" alt="图片" />
      </div>
      <h2>{{ item.title }}</h2>
      <p>&yen;{{ item.price }}</p>
      <span>月销{{ item.salesVolume }}</span>
    </li> -->
    <div
      class="item"
      v-for="(item, index) in dataList"
      :key="index"
      @click="toDetails(item.id)"
    >
      <div class="top">
        <span class="tag">{{ item.prescriptionType }}</span>
        <div class="image">
          <img :src="item.picHead" mode="" />
        </div>
        <div class="top_title">{{ item.title }}</div>
        <div class="dis">{{ item.remarks || "--" }}</div>
      </div>

      <div class="info">
        <div class="title font26">
          {{ item.title }}
        </div>
        <div class="price colormain font30">
          ￥{{ item.prescriptionSpecList[0].specCost || 0 }}/次
        </div>
        <div class="dis font22">月销{{ item.salesVolume || 0 }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
    },
    type: {
      type: Number,
    },
  },
  mounted() {},
  methods: {
    toDetails(id) {
      this.$router.push({
        path: "productionDetails",
        query: {
          id: id,
          type: this.type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// .list_box {
//   width: 95%;
//   margin: 0 auto 20px;
//   display: flex;
//   justify-content: space-between;
//   flex-wrap: wrap;
.shop_list {
  width: 95%;
  margin: 0 auto 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.shop_list .item {
  width: calc(50% - 15px);
}
.shop_list .item .top {
  background-color: #13233a;
  height: 340px;
  width: 100%;
  // position: relative;
}
.shop_list .item .top .tag {
  position: absolute;
  padding: 6px 20px;
  background-color: #67839a;
  color: #152944;
  border: 20px;
  border-radius: 25px;
  font-size: 24px;
  z-index: 0;
}
.shop_list .item .top .image {
  width: 100px;
  height: 100px;
  margin: 20px auto 5px;
  border-radius: 50%;
  overflow: hidden;
}
.shop_list .item .image img {
  width: 100%;
  height: 100%;
}
.shop_list .item .top .top_title {
  color: #fff;
  font-weight: bold;
  text-align: center;
  width: 100%;
  font-size: 28px;
  margin-top: 10px;
}
.shop_list .item .top .dis {
  margin: 20px;
  span-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  span-overflow: ellipsis;
  display: -webkit-box;
  color: #37708F;
  line-height: 40px;
  -webkit-line-clamp: 3;
  font-size: 24px;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.shop_list .item {
  background-color: #232a44;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  margin-top: 20px;
  overflow: hidden;
}

.shop_list .item .info {
  padding: 20px;
}

.shop_list .item .info .title {
  color: #8cbcd6;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 26px;
}
.shop_list .item .info .price {
  margin: 20px 0;
  color: #00CCFF;
  font-size: 30px;
}
.shop_list .item .info .dis {
  color: #7f89b3;
  font-size: 22px;
}
// }
</style>
